import { Component, inject, Input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Meldung } from '@app/shared/classes/meldung';
import { Notiz, NotizBlvCmd } from '@app/shared/classes/notiz';
import { BackendService } from '@app/shared/services/backend.service';
import { TranslatePipe } from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'notiz-blv-edit',
  templateUrl: './meldung-notiz-blv-edit.component.html',
  imports: [
    FormsModule,
    TranslatePipe,
  ]
})
export class MeldungNotizBlvEditComponent {
  private readonly backendService = inject(BackendService);

  private id?: number;
  protected readonly notizBlv = signal('');
  protected readonly offeneAnfrage = signal(false);

  readonly result = output<Meldung>();

  @Input()
  set notiz(value: Notiz | undefined) {
    this.id = value?.id;
    this.notizBlv.set(value?.notizBlv ?? '');
    this.offeneAnfrage.set(value?.offeneAnfrage ?? false);
  }

  protected save(): void {
    if (!this.id) {
      throw new Error("Target not set");
    }
    const notiz: NotizBlvCmd = {
      id            : this.id,
      notizBlv      : this.notizBlv(),
      offeneAnfrage : this.offeneAnfrage()
    };

    this.backendService.saveNotizBlv(notiz)
      .subscribe((meldung) => {
        Swal.close();
        this.result.emit(meldung);
      });
  }

  protected delete(): void {
    if (!this.id) {
      throw new Error("Target not set");
    }
    const notiz: NotizBlvCmd = {
      id            : this.id,
      notizBlv      : null,
      offeneAnfrage : this.offeneAnfrage()
    };

    this.backendService.saveNotizBlv(notiz)
      .subscribe((meldung) => {
        Swal.close();
        this.result.emit(meldung);
      });
  }
}
